import { Despesa } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<Despesa>('despesa');
